import React from "react";
import {connect} from "react-redux";
import RegistrationForm from "./RegistrationForm";
import RegistrationReceived from "./RegistrationReceived";
import {registrationAttributesChanged} from "../actions/authenticationActions";

export const RegisterUser = (props) => {
    const { companyId } = props.location.query;
    props.setCompanyDetails({ companyId });
    return (
        props.registrationReceived ? <RegistrationReceived /> : <RegistrationForm/>
    );
};

const mapStateToProps = (state) => ({
    registrationReceived: state.authentication.registration.submissionStatus.success
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setCompanyDetails: details => dispatch(registrationAttributesChanged(details))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/RegisterUser.js
 **/